// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* inspired by: https://css-tricks.com/responsive-data-tables/ */

.responsiveTable td .tdBefore {
    display: none;
  }
  
  /* @media screen and (max-width: 1427px) { */
  @media screen and (max-width: 768px) {
    /*
      Force table elements to not behave like tables anymore
      Hide table headers (but not display: none; for accessibility)
    */
  
    .responsiveTable table,
    .responsiveTable thead,
    .responsiveTable tbody,
    .responsiveTable th,
    .responsiveTable td,
    .responsiveTable tr {
      display: block;
    }
  
    .responsiveTable thead tr {
      position: absolute;
      top: -999px;
      left: -999px;
    }
  
    .responsiveTable tbody tr {
      /* padding: 0.25em; */
    }
  
    .responsiveTable td.pivoted {
      /* Behave like a "row" */
  
      border: none !important;
      position: relative;
      padding-left: calc(50% + 10px) !important;
      text-align: left !important;
      white-space: pre-wrap;
      overflow-wrap: break-word;
      border-bottom: 1px solid lightgrey !important;
      display: flex;
      align-items: center;
    }
  
    .responsiveTable td .tdBefore {
      /* Now like a table header */
      position: absolute;
      display: block;
  
      /* Top/left values mimic padding */
      left: 1rem;
      width: calc(50% - 20px);
      white-space: pre-wrap;
      overflow-wrap: break-word;
      text-align: left !important;
      font-weight: 600;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE;IACI,aAAa;EACf;;EAEA,4CAA4C;EAC5C;IACE;;;KAGC;;IAED;;;;;;MAME,cAAc;IAChB;;IAEA;MACE,kBAAkB;MAClB,WAAW;MACX,YAAY;IACd;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,wBAAwB;;MAExB,uBAAuB;MACvB,kBAAkB;MAClB,yCAAyC;MACzC,2BAA2B;MAC3B,qBAAqB;MACrB,yBAAyB;MACzB,6CAA6C;MAC7C,aAAa;MACb,mBAAmB;IACrB;;IAEA;MACE,4BAA4B;MAC5B,kBAAkB;MAClB,cAAc;;MAEd,kCAAkC;MAClC,UAAU;MACV,uBAAuB;MACvB,qBAAqB;MACrB,yBAAyB;MACzB,2BAA2B;MAC3B,gBAAgB;IAClB;EACF","sourcesContent":["/* inspired by: https://css-tricks.com/responsive-data-tables/ */\n\n.responsiveTable td .tdBefore {\n    display: none;\n  }\n  \n  /* @media screen and (max-width: 1427px) { */\n  @media screen and (max-width: 768px) {\n    /*\n      Force table elements to not behave like tables anymore\n      Hide table headers (but not display: none; for accessibility)\n    */\n  \n    .responsiveTable table,\n    .responsiveTable thead,\n    .responsiveTable tbody,\n    .responsiveTable th,\n    .responsiveTable td,\n    .responsiveTable tr {\n      display: block;\n    }\n  \n    .responsiveTable thead tr {\n      position: absolute;\n      top: -999px;\n      left: -999px;\n    }\n  \n    .responsiveTable tbody tr {\n      /* padding: 0.25em; */\n    }\n  \n    .responsiveTable td.pivoted {\n      /* Behave like a \"row\" */\n  \n      border: none !important;\n      position: relative;\n      padding-left: calc(50% + 10px) !important;\n      text-align: left !important;\n      white-space: pre-wrap;\n      overflow-wrap: break-word;\n      border-bottom: 1px solid lightgrey !important;\n      display: flex;\n      align-items: center;\n    }\n  \n    .responsiveTable td .tdBefore {\n      /* Now like a table header */\n      position: absolute;\n      display: block;\n  \n      /* Top/left values mimic padding */\n      left: 1rem;\n      width: calc(50% - 20px);\n      white-space: pre-wrap;\n      overflow-wrap: break-word;\n      text-align: left !important;\n      font-weight: 600;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
